import { render, staticRenderFns } from "./bookingId.vue?vue&type=template&id=0c5d8638&scoped=true"
import script from "./bookingId.vue?vue&type=script&lang=js"
export * from "./bookingId.vue?vue&type=script&lang=js"
import style0 from "./bookingId.vue?vue&type=style&index=0&id=0c5d8638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d8638",
  null
  
)

export default component.exports